<app-user-profile></app-user-profile>


@if(!detailsUpdated) {
<div class="pd info-panel mt-4" *ngIf="showForm">
    <form nz-form [formGroup]="bioDataForm" (ngSubmit)="submitBioDataForm()">
        <nz-form-item>
            <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
                <!-- <nz-form-label nzFor="address" nzRequired>Enter Your Address</nz-form-label> -->
                <nz-form-control>
                    <input nz-input class="v2-input" name="address"
                        placeholder="{{'PROFILE.INSTITUTION-DETAIL.ADDRESS' | translate | titlecase}}"
                        formControlName="address" type="text" id="address" />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item *ngIf="userType !== userTypes.VERIFIER">
            <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
                <!-- <nz-form-label nzFor="numberOfYear" nzRequired>Years Lived In Address</nz-form-label> -->
                <nz-form-control>
                    <input class="v2-input" nz-input placeholder="{{'PROFILE.YEARS_LIVED' | translate}}"
                        name="numberOfYear" formControlName="address_duration" [min]="1" type="number"
                        id="numberOfYear" />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item *ngIf="userType !== userTypes.VERIFIER">
            <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
                <!-- <nz-form-label nzFor="former_name">Former / Maiden Name</nz-form-label> -->
                <nz-form-control>
                    <input class="v2-input" nz-input name="former_name"
                        placeholder="{{'PROFILE.FORMER_NAME' | translate}}" formControlName="former_name" type="text"
                        id="former_name" />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item *ngIf="userType === userTypes.VERIFIER">
            <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
                <!-- <nz-form-label nzFor="description">Description</nz-form-label> -->
                <nz-form-control>
                    <textarea rows="3" type="text" nz-input formControlName="description" id="description"
                        name="description"></textarea>
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item *ngIf="userType === userTypes.VERIFIER">
            <nz-col nzXs="24" class="switch-wrapper">
                <nz-switch #switch formControlName="email_public" [nzSize]="'small'"
                    (ngModelChange)="onToggleSwitch(switch.isChecked)"></nz-switch> &nbsp;

                <span class="span-left"> {{emailDisplayConfirmation}} </span>
            </nz-col>
        </nz-form-item>

        <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="8" [nzXXl]="6">
                <button nz-button [nzType]="'primary'" [nzLoading]="loading"
                    [disabled]="(!bioDataForm.valid && userType === userTypes.USER) || (userType === userTypes.VERIFIER && (bioDataForm.get('address').invalid || !description?.length))"
                    nzBlock>
                    {{('GENERAL.SUBMIT' | translate) | uppercase}}
                </button>
            </nz-form-control>
            <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="8" [nzXXl]="6">
                <button nz-button class="btn-clear" (click)="hideEditForm()" [nzLoading]="loading" nzBlock>
                    {{'GENERAL.CANCEL' | translate | uppercase}}
                </button>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>

@if(!showForm) {
@if(userType === userTypes.USER && user?.additional_detail) {
<div class="info-panel mt-4">
    <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16">
            <div>
                <p class="label">{{'PROFILE.ADDRESS_DETAILS' | translate | uppercase}}</p>
                @if(!fetching) {
                <p class="value">{{biodata?.address}}</p>
                } @else {
                <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
                }
            </div>

            <div>
                <p class="label">{{'PROFILE.YEARS_LIVED' | translate | uppercase}}</p>
                @if(!fetching) {
                <p class="value">{{biodata?.address_duration}}</p>
                } @else {
                <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
                }
            </div>

            <div>
                <p class="label">{{'PROFILE.FORMER_NAME' | translate | uppercase}}</p>
                @if(!fetching) {
                <p class="value">{{biodata?.former_name || '-'}}</p>
                } @else {
                <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
                }
            </div>
        </div>

        @if(user?.additional_detail && user?.additional_detail?.identity_verified === false) {

        <div nz-col class="btn-wrapper" nzXs="24" nzSm="24" nzMd="24" nzLg="8" nzXl="8">
            @if(!fetching) {
            <button (click)="showEditForm()" class="btn-clear">
                <img src="assets/v2/icons/edit.svg" alt="">
                <span>{{'GENERAL.EDIT_INFO' | translate}}</span>
            </button>
            }
        </div>
        }

    </div>
</div>
}
@if(userType === userTypes.VERIFIER) {
<app-institution-detail></app-institution-detail>
}

}
}